import { useCallback, useState } from "react";
import { $POST } from "../../../../api";
import Router from "../../../../const/router";
// Helpers
import resetForm from "../../../../helpers/resetForm";

const AdminSkillsForm = () => {
  const [name, setName] = useState("");

  const submitForm = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        await $POST(Router.SKILLS, {
          name,
        });
        resetForm([setName]);
      } catch (err) {
        throw new Error(err.message);
      }
    },
    [name]
  );

  return (
    <form className="admin-form" onSubmit={submitForm}>
      <h1 className="section-mention">Add Skill </h1>
      <hr className="section-hr" />
      <div className="admin-form-fields">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          type="text"
          placeholder="Skill Name"
        />

        <button>Add</button>
      </div>
    </form>
  );
};

export default AdminSkillsForm;
